import { AbstractControl } from '@angular/forms';

export class FechaNacimientoValidator {
	static ValidAge(control: AbstractControl) {
		const fechaNacimiento = control.get('fechaNacimiento').value;

		// let age = this.getAge(fechaNacimiento);

		let today = new Date();
		let birthDate = new Date(fechaNacimiento);
		let age = today.getFullYear() - birthDate.getFullYear();
		let m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}

		if (age < 18) {
			control.get('fechaNacimiento').setErrors({FechaNacimiento: true});
		} else {
			return null;
		}
	}

	static getAge(DOB) {
		let today = new Date();
		let birthDate = new Date(DOB);
		let age = today.getFullYear() - birthDate.getFullYear();
		let m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age;
	}
}
